import * as React from "react"

import { cn } from "@/lib/utils"

const TextareaBase = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
TextareaBase.displayName = "Textarea"

// --- uiv2: conditional Intui swap (build-time resolved by Vite) ---
import { IntuiTextarea } from '@/components/intueri/IntuiTextarea'

const _uiv2 = import.meta.env.VITE_UIV2 === 'true'
const Textarea = _uiv2 ? (IntuiTextarea as typeof TextareaBase) : TextareaBase

export { Textarea }
